import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { useToast } from '@projectK/context/ToastProvider';
import PropTypes from 'prop-types';
import { WaitlistDashboardMain } from '@projectK/MainComponents';
 
const ActivityWaitlist = ({
  waitListData,
  loading,
  fetchWaitList,
  fetchActivitySessions,
  fetchUserProduct,
  setLoading,
}) => {
  const showToast = useToast();
  const { user } = useAuthUser();
  const infoViewActionsContext = useInfoViewActionsContext();
  const { isMobile, mobileMode } = useMobileSettings();
 
  const handleCancelUp = async (
    ids,
    userId,
    activity_session_id,
    product_id,
  ) => {
    try {
      setLoading(true);
      await jwtAxios.delete(`/user-waitlist/${ids}`, {
        params: {
          user_id: userId,
          activity_session_id,
          product_id: product_id,
        },
      });
      setLoading(false);
      fetchWaitList();
      fetchActivitySessions();
      if (!isMobile) {
        fetchUserProduct();
        infoViewActionsContext.showMessage(`Cancelled session successfully`);
      } else {
        showToast('Cancelled session successfully.', 'success', mobileMode);
      }
    } catch (error) {
      setLoading(false);
      if (isMobile) {
        showToast(error?.response?.data?.error, 'error', mobileMode);
      } else {
        infoViewActionsContext.fetchError(error?.response?.data?.error);
      }
    }
  };
 
  function getTruncatedAddressTitle(data) {
    const address = data?.address ?? '';
    const locationName = data?.location_name ?? '';
    return `${address}${locationName}`.substring(0, 50);
  }
 
  if (loading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' p={2}>
        <CircularProgress />
      </Box>
    );
  }
 
  if (!waitListData || waitListData.length === 0) {
    return (
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{ textAlign: 'center', py: 2, fontWeight: '600' }}
          >
            No waitlist data
          </Typography>
        </CardContent>
      </Card>
    );
  }
 
  return (
    <WaitlistDashboardMain
      waitListData={waitListData}
      getTruncatedAddressTitle={getTruncatedAddressTitle}
      handleCancelUp={handleCancelUp}
      user={user}
    />
  );
};
 
export default ActivityWaitlist;
ActivityWaitlist.propTypes = {
  waitListData: PropTypes.array,
  loading: PropTypes.bool,
  fetchWaitList: PropTypes.func,
  fetchActivitySessions: PropTypes.func,
  fetchUserProduct: PropTypes.func,
  setLoading: PropTypes.func,
};
